import { useRef, useState } from "react"
import { Tooltip as ReactTooltip } from "react-tooltip"
import styled from "styled-components"

import { HelpFaqModal } from "modals/HelpFaqModal"

import localStyles from "./index.module.scss"

const HelpIconWrapper = styled.div`
  display: flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
    border-radius: 8px;
  }

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    border: 0;
    background: transparent;
    cursor: pointer;
  }
`

const HelpFaqIconSvg = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true" focusable="false">
    <mask id="help-faq-icon-cutout">
      <rect width="18" height="18" fill="black" />
      <circle cx="9" cy="9" r="9" fill="white" />
      <path
        d="M9 13C8.61 13 8.25 13.36 8.25 13.75C8.25 14.14 8.61 14.5 9 14.5C9.39 14.5 9.75 14.14 9.75 13.75C9.75 13.36 9.39 13 9 13Z"
        fill="black"
      />
      <path
        d="M9 4.5C7.34 4.5 6 5.84 6 7.5C6 7.9 6.3 8.2 6.7 8.2C7.1 8.2 7.4 7.9 7.4 7.5C7.4 6.62 8.12 5.9 9 5.9C9.88 5.9 10.6 6.62 10.6 7.5C10.6 8.1 10.17 8.45 9.53 8.92C8.65 9.57 7.5 10.42 7.5 12C7.5 12.4 7.8 12.7 8.2 12.7C8.6 12.7 8.9 12.4 8.9 12C8.9 11.06 9.44 10.68 10.16 10.15C10.98 9.56 12 8.79 12 7.5C12 5.84 10.66 4.5 9 4.5Z"
        fill="black"
      />
    </mask>
    <circle cx="9" cy="9" r="9" fill="#FFFFFF" mask="url(#help-faq-icon-cutout)" />
  </svg>
)

export const HelpFaqIcon = () => {
  const [isHelpFaqOpen, setIsHelpFaqOpen] = useState(false)
  const triggerRef = useRef<HTMLDivElement>(null)

  return (
    <>
      <HelpIconWrapper ref={triggerRef}>
        <button
          type="button"
          data-tooltip-id="tooltip-help-faq"
          aria-label="Help & FAQ"
          onClick={() => setIsHelpFaqOpen(true)}
        >
          <HelpFaqIconSvg />
        </button>
        <ReactTooltip delayShow={500} className={localStyles.tooltip} id="tooltip-help-faq">
          Help & FAQ
        </ReactTooltip>
      </HelpIconWrapper>
      {isHelpFaqOpen && <HelpFaqModal onCancel={() => setIsHelpFaqOpen(false)} triggerRef={triggerRef} />}
    </>
  )
}
